import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  cdSectionTitle: {
    width: "100%",
    marginBottom: theme.spacing(2),
    fontFamily: "Courier Prime",
    fontSize: theme.typography.h5.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    textTransform: "uppercase",
    color: theme.palette.primary.main
  }
}));
